import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AxsButtonComponent,
  AxsHorizontalRuleComponent,
  AxsSelectDropdownComponent,
  AxsToggleComponent,
  AxsTooltipComponent,
} from '@vanguard/axs-angular';
import { AxsTabComponent, AxsTabsComponent } from '@vanguard/axs-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GatekeeperService } from './shared/services/gatekeeper/gatekeeper.service';
import { SharedInfoService } from './shared/services/shared-info/shared-info.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    AxsButtonComponent,
    AxsToggleComponent,
    AxsHorizontalRuleComponent,
    AxsSelectDropdownComponent,
    AxsTooltipComponent,
    AxsTabComponent,
    AxsTabsComponent,
  ],
  providers: [
    provideAppInitializer(async () => {
      const gatekeeperService = inject(GatekeeperService);

      await gatekeeperService.setFeatureToggleList();
    }),
    provideAppInitializer(() => {
      const initializerFn = (
        (clientInfoService: SharedInfoService) => () =>
          clientInfoService.initializeService()
      )(inject(SharedInfoService));
      return initializerFn();
    }),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
